/**
 * Timing Configuration
 * Contains animation durations, debounce delays, and timing thresholds
 */

export const TIMING = {
  NAVBAR_DEBOUNCE: 150,
  TRANSITION_DURATION: 500,
  DEBOUNCE_DELAY: 300,
  SCROLL_TO_TOP_THRESHOLD: 300,
  STICKY_THRESHOLD: 200,
  INITIAL_SCROLL_DELAY: 100,
  LAYOUT_DELAY: 300,
  ALERT_FADE_OUT: 200,
} as const;
